import Statistic from 'antd/es/statistic/Statistic';
import { withConfigProvider } from '../config-provider';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export default withConfigProvider(Statistic);
